<div class="layout-topbar">
    <div class="topbar-start">
        <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>

        <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
    </div>

    <div class="topbar-end">
        <ul class="topbar-menu">
            <li class="topbar-search">
                <button
                    type="button"
                    class="unit-switcher-trigger"
                    (click)="layoutService.showUnitSwitcherPalette()">
                    <i class="pi pi-building text-400"></i>
                    <span class="unit-switcher-trigger-label">{{ getActiveUnitLabel() }}</span>
                    <kbd>Ctrl K</kbd>
                </button>
            </li>
            <div class="ml-2 cursor-pointer" *ngIf="!loadingAppStatus" (click)="NavigateToOpenCloseApp()">
                <div *ngIf="appContext.food.isOpen || appContext.drinks.isOpen" class="border-circle w-2rem h-2rem flex align-items-center justify-content-center" style="background: #defade; border: 1px solid #bce7bc;">
                    <i class="pi pi-sun" style="color: #16651a;"></i>
                </div>
                <div *ngIf="!appContext.food.isOpen && !appContext.drinks.isOpen" class="border-circle w-2rem h-2rem flex align-items-center justify-content-center" style="background: #ece9fc; border: 1px solid #cfcaef;">
                    <i class="pi pi-moon" style="color: #2a1261;"></i>
                </div>
            </div>
            <li class="ml-2 topbar-profile">
                <button pButton icon="pi pi-user" type="button" class="" (click)="onProfileButtonClick()">

                </button>
            </li>
            
        </ul>
    </div>
</div>
